import React, { useEffect, useState } from "react";
import CommonTable from "../common/CommonTable";
import CommonModal from "../common/CommonModal";
import { useNavigate, useParams } from "react-router-dom";
import { useUser } from "../Commonfunction/UserContext";
import { getData, postData } from "../Commonfunction/CommonFunction";
import { checkPermission } from "../Commonfunction/NewPermission";
import TopHeading from "../common/TopHeading";
import PermissionMessage from "../common/PermissionMessage";
import DeleteConfirmationModal from "../common/DeleteConfirmationModal";
import { TbEdit } from "react-icons/tb";
import { RiDeleteBin6Line } from "react-icons/ri";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  MdArrowCircleDown,
  MdCalculate,
  MdEmail,
  MdMarkEmailRead,
  MdRemoveRedEye,
} from "react-icons/md";
import FormHeading from "../common/FormHeading";
import { IoMdDownload } from "react-icons/io";
import "../../assets/style/client.css";
import AddPrivousMonthTax from "./AddPrivousMonthTax";
import AddPrivousMonthTaxMaster from "./AddPrivousMonthTaxMaster";

export default function AllClients({ dashboard }) {
  const { role, setUserAccess } = useUser();
  const userType = localStorage.getItem("user_type");
  const employeeType = localStorage.getItem("employee_type");
  const [customerStatusUrl, setCustomerStatusUrl] =
    useState("/api/all-customers");
  const [tableData, setTableData] = useState([]);
  const [permissionsData, setPermissionsData] = useState({});
  const { id, employeeId } = useParams();
  const navigate = useNavigate();
  const [rowId, setRowId] = useState();
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isLoadings, setIsLoading] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showFilterModalMaster, setShowFilterModalMaster] = useState(false);
  const [permissionMassage, setPermissionMassage] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [importDataPrivousMonth, setImportDataPrivousMonth] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [businessTypeData, setBusinessTypeData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [buffer, setBuffer] = useState(false);

  const handleClose = () => {
    setShowEmailModal(false);
    setShowFilterModal(false);
    setShowFilterModalMaster(false);
    setImportDataPrivousMonth(false);
    setRowId();
  };

  const downloadFile = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownload = async (id) => {
    try {
      const result = await getData(`/api/tax-calculation-report-export/${id}`);
      if (result) {
        const fileUrl = result.url;
        downloadFile(fileUrl);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleStatusToggle = async (id, newStatus) => {
    try {
      const request_url = `/api/update-customer-status/${id}`;
      const response = await postData(request_url, { is_active: newStatus });
      if (response.success) {
        toast.success(response.message);
        fetchData();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log("Error: ", error);
      toast.error("Failed to update status");
    }
  };

  // Fixed checkbox selection handlers
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      // Select all rows
      const allIds = indexedRows.map((row) => row.id);
      setSelectedRowIds(allIds);
      setSelectedRows({ customer_ids: allIds });
    } else {
      // Deselect all rows
      setSelectedRowIds([]);
      setSelectedRows({ customer_ids: [] });
    }
  };

  const handleSelectRow = (e, rowId) => {
    const isChecked = e.target.checked;

    setSelectedRowIds((prevSelected) => {
      let newSelected;

      if (isChecked) {
        // Add this row to selected
        newSelected = [...prevSelected, rowId];
      } else {
        // Remove this row from selected
        newSelected = prevSelected.filter((id) => id !== rowId);
      }

      // Update the selectedRows state for API calls
      setSelectedRows({ customer_ids: newSelected });

      // Update selectAll checkbox state
      if (newSelected.length === indexedRows.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }

      return newSelected;
    });
  };

  // Define columns with fixed checkbox implementation
  const columns = [
    ...(userType === "CPA"
      ? [
          {
            key: "select",
            label: (
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id="select-all"
                  className="custom-checkbox"
                  checked={selectAll}
                  onChange={handleSelectAll}
                />
                <label htmlFor="select-all" className="checkbox-label"></label>
              </div>
            ),
            width: 60,
            renderCell: (params) => (
              <div className="checkbox-container">
                <input
                  type="checkbox"
                  id={`select-row-${params.id}`}
                  className="custom-checkbox"
                  checked={selectedRowIds.includes(params.id)}
                  onChange={(e) => handleSelectRow(e, params.id)}
                />
                <label
                  htmlFor={`select-row-${params.id}`}
                  className="checkbox-label"
                ></label>
              </div>
            ),
          },
        ]
      : []),
    {
      key: "status",
      label: "Status",
      renderCell: (params) => (
        <div className="status-toggle-container">
          <div className="modern-switch modern-switch--small">
            <input
              type="checkbox"
              className="modern-switch__input"
              id={`status-switch-${params.id}`}
              defaultChecked={params?.is_active === 1}
              onChange={(event) =>
                handleStatusToggle(params.id, event.target.checked ? 1 : 0)
              }
            />
            <label
              className="modern-switch__label"
              htmlFor={`status-switch-${params.id}`}
            >
              <span className="modern-switch__button"></span>
              <span className="modern-switch__text">
                {params?.row?.is_active === 1 ? "Active" : ""}
              </span>
            </label>
          </div>
        </div>
      ),
    },

    {
      key: "action",
      label: "Action",
      width: userType === "CPA" ? 270 : 180,
      renderCell: (params) => {
        const id = params?.id;
        const row = params;
        const showEmailBtn =
          employeeType === "email_operator" || userType === "CPA";

        return (
          <div className="action-button-container">
            {/* Download */}
        
            {/* CPA Buttons */}
            {userType === "CPA" && (
              <>
                <button
                  className="action-button edit"
                  title="Edit"
                  onClick={() =>
                    fetchDataUserAccess(
                      "edit",
                      false,
                      params,
                      `/edit-client/${id}`
                    )
                  }
                >
                  <TbEdit size={18} />
                </button>

                <button
                  className="action-button delete"
                  title="Delete"
                  onClick={() =>
                    fetchDataUserAccess("delete", true, params, "")
                  }
                >
                  <RiDeleteBin6Line size={18} />
                </button>

                <button
                  className="action-button view"
                  title="View Files"
                  onClick={() => {
                    navigate(`/customer-file/${id}`, {
                      state: {
                        fileData: row.files,
                      },
                    });
                  }}
                >
                  <MdRemoveRedEye size={18} />
                </button>
              </>
            )}

            {/* Employee View Button */}
            {userType === "Employee" && (
              <button
                className="action-button view"
                title="View Files"
                onClick={() => {
                  navigate(`/customer-file/${id}`, {
                    state: {
                      fileData: row.files,
                    },
                  });
                }}
              >
                <MdRemoveRedEye size={16} />
              </button>
            )}
          </div>
        );
      },
    },
    {
      key: "download",
      label: "Download",
      width: 90,
      renderCell: (params) => {
        const id = params?.id;
    
        return (
          <button
            className="action-button download"
            title="Download File"
            onClick={() => {
              setShowFilterModal(id);
              setRowId(id);
            }}
          >
            <MdArrowCircleDown size={18} />
          </button>
        );
      },
    },
    
    // Add Tax Button Column
    {
      key: "add_tax",
      label: "Add Tax",
      width: 100,
      renderCell: (params) => {
        const id = params?.id;
        const row = params;

        return (
          <button
            className="action-button tax"
            title="Add Tax"
            onClick={() => {
              if (row?.tax_head_email_sent !== 0) {
                navigate(`/add-tax/${id}`, {
                  state: { activeStep: "panel5" },
                });
              }
            }}
            disabled={row?.tax_head_email_sent === 0}
          >
            <MdCalculate size={18} />
          </button>
        );
      },
    },

    // Email Button Column
    {
      key: "email_action",
      label: "Email",
      width: 100,
      renderCell: (params) => {
        const id = params?.id;
        const row = params;
        const showEmailBtn =
          employeeType === "email_operator" || userType === "CPA";

        if (!showEmailBtn) return null;

        return row?.tax_head_email_sent === 0 ? (
          <button
            className="action-button email"
            title="Send Email"
            onClick={() => {
              setShowEmailModal(true);
              setRowId(id);
            }}
          >
            <MdEmail size={16} />
          </button>
        ) : (
          <button className="action-button email" title="Email Sent" disabled>
            <MdMarkEmailRead size={16} />
          </button>
        );
      },
    },

    { key: "company_name", label: "Company Name", sortable: true },
    // { key: "customer_name", label: "Client Name", sortable: true },
    { key: "business_type", label: "Business Type", sortable: true },
    // { key: "company_type", label: "Company Type", sortable: true },
    // { key: "email", label: "Email", sortable: true },
    // { key: "s_and_u_number", label: "S&U Number", sortable: true },
    { key: "state", label: "State", sortable: true },
    { key: "city", label: "City", sortable: true },
    { key: "zip_code", label: "Zip Code", sortable: true },
    {
      key: "import_data",
      label: "Add Past Data",
      sortable: true,
      width: 150,
      renderCell: (params) => (
        <button
          className="btn-primary modern-compact-btn"
          onClick={() => {
            setImportDataPrivousMonth(true);
            setRowId(params.id);
          }}
        >
          <span>Add Past Data</span>
        </button>
      ),
    },
  ].filter(Boolean);

  const fetchDataUserAccess = async (method, showPopup, params, goToLink) => {
    try {
      const result = await getData("/api/user-access");
      if (result.success) {
        setUserAccess(result);
        checkPermission(role, method, result.permission)
          ? showPopup
            ? method == "delete"
              ? (setOpen(true), setRowId(params.id))
              : params
              ? (setRowId(params.id), setShowModal(true))
              : (setRowId(null), setShowModal(true))
            : goToLink
            ? navigate(goToLink)
            : ""
          : setPermissionMassage(true);
      }
    } catch (error) {
      console.log("Error:123213", error);
    }
  };

  const fetchData = async () => {
    setTableData([]);
    setIsLoading(true);
    try {
      const api = employeeId
        ? `/api/get-customers-by-employee-id/${id}/${employeeId}`
        : dashboard === "dashboard"
        ? `/api/all-customers-by-emp-id/${id}`
        : customerStatusUrl;
      const result = await getData(api);
      if (result.success) {
        setTableData(result.data);
        setIsLoading(false);
        setPermissionsData(result?.permission || {});
        // Reset selection states when data changes
        setSelectedRowIds([]);
        setSelectedRows({ customer_ids: [] });
        setSelectAll(false);
        if (!checkPermission("Customers", "view", result.permission)) {
          setPermissionMassage(true);
          setTimeout(() => {
            navigate("/");
          }, 2000);
        }
      } else {
        setPermissionsData(result?.permission || {});
        setIsLoading(false);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const indexedRows = tableData.map((data, index) => ({
    index: index + 1,
    id: data.id,
    customer_name: data.customer_name || "-",
    company_name: data.company_name || "-",
    company_type: data.company_type || "-",
    s_and_u_number: data.s_and_u_number || "-",
    ein_number: data.ein_number || "-",
    mailFlag: data?.mailFlag,
    tax_head_email_sent: data?.tax_head_email_sent,
    file_status: data?.file_status,
    business_type: data?.business_type,
    email: data?.email,
    is_active: data?.is_active,
    files: data?.files,
    state: data?.state,
    city: data?.city,
    zip_code: data?.zip_code,
  }));

  useEffect(() => {
    fetchData();
    fetchBusinessTypeData();
  }, [customerStatusUrl]);

  const fetchBusinessTypeData = async () => {
    try {
      const result = await getData("/api/all-tax-heads-listing");
      if (result.success) {
        const typeData = result?.data?.map((item) => {
          return { label: item.business_type, value: item.business_type };
        });
        setBusinessTypeData(typeData);
      } else {
        // setPermissionsData(result.permission);
      }
    } catch (error) {
      console.log("Error: ", error);
    }
  };

  const handleSubmit = async (values) => {
    setSubmitLoader(true);
    try {
      const request_url = `/api/notify-customer/${values}`;
      const postDataResult = await postData(request_url, values);
      await toast.success(postDataResult.message);
      await fetchData();
      await handleClose();
      await setPermissionMassage(false);
      setSubmitLoader(false);
    } catch (error) {
      toast.error(error.response.data.message);
      setSubmitLoader(false);
    }
  };

  const handleSubmitMultipMail = async (values) => {
    setSubmitLoader(true);
    setBuffer(true);
    try {
      const request_url = `/api/notify-all-customers`;
      const postDataResult = await postData(request_url, values);
      await toast.success(postDataResult.message);
      await fetchData();
      setSubmitLoader(false);
      setBuffer(false);
    } catch (error) {
      toast.error(error.response.data.message);
      setSubmitLoader(false);
      setBuffer(false);
    }
  };

  return (
    <div className="width-full">
      {employeeId ? (
        <FormHeading
          heading={employeeId ? "All Clients" : "CPA"}
          isHideBtn={employeeId ? false : true}
          path={`/${id}`}
        />
      ) : (
        <TopHeading
          heading="All Clients"
          isHideBtn={userType === "CPA"}
          path="/Client"
          csvFileUpload={true}
          csvName="Import Customer"
          csvExportName="Import Customer Files"
          fetchData={fetchData}
          isLoading={isLoadings}
          businessTypeData={businessTypeData}
        />
      )}

      {userType == "CPA" ? (
        <div>
          <div className="tf-container">
            <div className="tf-wrapper">
              <div className="tf-title-area">
              <div className="tf-buttons">
                <div
                  className={`tf-button ${
                    customerStatusUrl === "/api/all-customers"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() => setCustomerStatusUrl("/api/all-customers")}
                >
                  <span className="tf-button-text"> ALL FILES</span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 6L9 17L4 12"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={`tf-button ${
                    customerStatusUrl === "/api/get-files-by-status/pending"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() =>
                    setCustomerStatusUrl("/api/get-files-by-status/pending")
                  }
                >
                  <span className="tf-button-text"> PENDING</span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 6L6 18M6 6L18 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>

                <div
                  className={`tf-button ${
                    customerStatusUrl ===
                    "/api/get-files-by-status/submitted_for_review"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() =>
                    setCustomerStatusUrl(
                      "/api/get-files-by-status/submitted_for_review"
                    )
                  }
                >
                  <span className="tf-button-text"> SUBMITTED FOR REVIEW</span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M8 12L11 15L16 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={`tf-button ${
                    customerStatusUrl ===
                    "/api/get-files-by-status/disapproved_files"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() =>
                    setCustomerStatusUrl(
                      "/api/get-files-by-status/disapproved_files"
                    )
                  }
                >
                  <span className="tf-button-text">
                    {" "}
                    DISAPPROVED FILES OF THE MONTH
                  </span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 6L6 18M6 6L18 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={`tf-button ${
                    customerStatusUrl ===
                    "/api/get-files-by-status/approved_files"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() =>
                    setCustomerStatusUrl(
                      "/api/get-files-by-status/approved_files"
                    )
                  }
                >
                  <span className="tf-button-text">
                    {" "}
                    APPROVED FILES OF THE MONTH
                  </span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M8 12L11 15L16 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={`tf-button ${
                    customerStatusUrl ===
                    "/api/get-files-by-status/tax_panel_ready"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() =>
                    setCustomerStatusUrl(
                      "/api/get-files-by-status/tax_panel_ready"
                    )
                  }
                >
                  <span className="tf-button-text"> READY FOR TAX PANEL</span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M8 12L11 15L16 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={`tf-button ${
                    customerStatusUrl ===
                    "/api/get-files-by-status/uploaded_to_portal"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() =>
                    setCustomerStatusUrl(
                      "/api/get-files-by-status/uploaded_to_portal"
                    )
                  }
                >
                  <span className="tf-button-text"> UPLOADED TO PORTAL</span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                      stroke="currentColor"
                      strokeWidth="2"
                    />
                    <path
                      d="M8 12L11 15L16 9"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
                <div
                  className={`tf-button ${
                    customerStatusUrl === "/api/all-customers-inactive"
                      ? "btn-primary"
                      : "btn-primary-inactive"
                  }`}
                  onClick={() =>
                    setCustomerStatusUrl("/api/all-customers-inactive")
                  }
                >
                  <span className="tf-button-text"> Inactive</span>
                  <svg
                    className="tf-button-icon"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 6L6 18M6 6L18 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

                <div className="filter-action-buttons">
                  <button
                    type="button"
                    className="usa-button filter-action-btn-secondary"
                    onClick={() => {
                      if (tableData?.length) {
                        setShowFilterModalMaster(true);
                      }
                    }}
                    disabled={!tableData?.length}
                  >
                    <IoMdDownload style={{ fontSize: "20px" }} />
                    <span>Download</span>
                  </button>

                  <button
                    type="button"
                    className={`usa-button filter-action-btn-success ${
                      selectedRows?.customer_ids?.length
                        ? ""
                        : "filter-action-disabled"
                    }`}
                    onClick={() => handleSubmitMultipMail(selectedRows)}
                    disabled={
                      !selectedRows?.customer_ids?.length || submitLoader
                    }
                  >
                    <MdEmail style={{ fontSize: "20px" }} />
                    <span>{submitLoader ? "Sending..." : "All Email"}</span>
                  </button>
                </div>
              </div>

         
            </div>
          </div>
        </div>
      ) : (
        <div className="tf-buttons">
          <div
            className={`tf-button ${
              customerStatusUrl === "/api/all-customers"
                ? "btn-primary"
                : "btn-primary-inactive"
            }`}
            onClick={() => setCustomerStatusUrl("/api/all-customers")}
          >
            <span className="tf-button-text"> ALL FILES</span>
            <svg
              className="tf-button-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 6L9 17L4 12"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <div
            className={`tf-button ${
              customerStatusUrl === "/api/get-files-by-status/pending"
                ? "btn-primary"
                : "btn-primary-inactive"
            }`}
            onClick={() =>
              setCustomerStatusUrl("/api/get-files-by-status/pending")
            }
          >
            <span className="tf-button-text"> PENDING</span>
            <svg
              className="tf-button-icon"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      )}
      <CommonTable
        columns={columns}
        data={indexedRows || []}
        // onSelectionModelChange={handleRowSelection}
      />
      {open && (
        <DeleteConfirmationModal
          open={true}
          handleClose={() => setOpen(false)}
          request_url={`/api/delete-customer/${rowId}`}
          getApi={fetchData}
        />
      )}
      {permissionMassage && (
        <PermissionMessage
          open={true}
          handleClose={() => {
            setPermissionMassage(false);
          }}
        />
      )}
      {showEmailModal && (
        <CommonModal
          open={showEmailModal}
          onClose={handleClose}
          title="Notification"
        >
          <div className="usa-prose" style={{ padding: "1rem" }}>
            <div
              style={{
                textAlign: "center",
                fontSize: "1.2rem",
                marginBottom: "1rem",
              }}
            >
              Are you sure you want to send email to collect data?
            </div>

            <div
              className="usa-button-group"
              style={{ justifyContent: "flex-end" }}
            >
              <button
                type="button"
                className="usa-button usa-button--unstyled"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                type="button"
                className={`usa-button ${
                  submitLoader ? "usa-button--disabled" : ""
                }`}
                disabled={submitLoader}
                onClick={() => {
                  if (!submitLoader) handleSubmit(rowId);
                }}
              >
                {submitLoader ? "Loading..." : "Submit"}
              </button>
            </div>
          </div>
        </CommonModal>
      )}
      {showFilterModal && (
        <CommonModal
          open={showFilterModal}
          onClose={handleClose}
          title={"Download"}
          size="medium"
        >
          <div>
            <AddPrivousMonthTax
              id={rowId}
              onClose={handleClose}
              filter="filter"
              isDwonload={true}
            />
          </div>
        </CommonModal>
      )}

      {showFilterModalMaster && (
        <CommonModal
          open={showFilterModalMaster}
          onClose={handleClose}
          title={"Download Master"}
          size="medium"
        >
          <div>
            <AddPrivousMonthTaxMaster
              // id={rowId}
              onClose={handleClose}
              filter="filter"
              isDwonload={true}
              tableData={tableData}
            />
          </div>
        </CommonModal>
      )}

      {importDataPrivousMonth && (
        <CommonModal
          open={importDataPrivousMonth}
          onClose={handleClose}
          title={"Add Previous Month Data"}
          size="large"
          dashboardView="dashboardView"
        >
          <AddPrivousMonthTax id={rowId} onClose={handleClose} />
        </CommonModal>
      )}
    </div>
  );
}
